import { useHover } from '@uidotdev/usehooks';
import { Image } from 'antd';
import NoImage from 'components/etc/NoImage';
import ActionButton from 'components/table/ActionButton';
import { Edit2, Trash } from 'iconsax-react';
import { IVisible } from 'pages/assets/AssetsPage';
import React from 'react';
import { useCookies } from 'react-cookie';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { UserRole } from '../../../../utils/types/common';

interface IProps {
  el: any;
  visible: IVisible;
  setSelectedData: React.Dispatch<any>;
  selectedData: any;
  setVisible: React.Dispatch<React.SetStateAction<IVisible>>;
  handleClickDeleteModal: (record: any) => void;
}

const ItemBox: React.FC<IProps> = ({
  el,
  visible,
  setSelectedData,
  selectedData,
  setVisible,
  handleClickDeleteModal,
}) => {
  const [ref, hovering] = useHover();
  const [cookies] = useCookies();

  const tableActionMenu = (record) => {
    return [
      {
        key: 1,
        item: (
          <IconAcitonStyled>
            <Edit2
              size='24'
              onClick={() => {
                setSelectedData(record);
                setVisible({ ...visible, edit: true });
              }}
            />
          </IconAcitonStyled>
        ),
        hoverColor: theme.colors.blue_500,
        color: theme.colors.dark_200,
      },

      {
        key: 2,
        item: (
          <IconAcitonStyled>
            <Trash
              size='24'
              onClick={() => {
                handleClickDeleteModal(record);
              }}
            />
          </IconAcitonStyled>
        ),
        hoverColor: theme.colors.red_500,
        color: theme.colors.dark_200,
      },
    ];
  };
  const renderAction = (record) => {
    if (cookies?.loginAdmin?.role === UserRole.SuperAdmin) {
      const menus = [tableActionMenu(record)];
      return <ActionButton menus={menus} />;
    } else {
      return <></>;
    }
  };
  return (
    <ImageWrapper ref={ref}>
      {el?.image_url ? (
        <>
          {cookies?.loginAdmin?.role === UserRole.SuperAdmin ? (
            <>
              {hovering && (
                <div className='action-wrapper'>{renderAction(el)}</div>
              )}
            </>
          ) : (
            <></>
          )}
          <div className='image-section'>
            <Image
              src={el?.image_url}
              alt={el?.image_name}
              height='100%'
              width='100%'
              style={{ objectFit: 'contain' }}
            />
          </div>
          <div>
            <p className='text-margin'>
              {el?.id}. {el?.image_name}
            </p>
          </div>
        </>
      ) : (
        <>
          <div className='image-section'>
            <NoImage />
          </div>
          <p className='text-margin'>
            {el?.id}. {el?.image_name}
          </p>
        </>
      )}
    </ImageWrapper>
  );
};

export default ItemBox;

const ImageWrapper = styled.div`
  position: relative;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  padding: 16px 16px 16px 16px;
  /* width: 332px; */
  height: 350px;

  border-radius: 8px;
  .image-section {
    width: 100%;
    height: 300px;
  }
  .action-wrapper {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 1;
  }
  p {
    margin-bottom: 16px;
    color: #000000;
    font-weight: ${theme.fontWeights.normal};
    font-size: ${theme.fontSizes.normal};
  }
`;

const IconAcitonStyled = styled.div`
  padding: 8px;
  width: 34px;
  height: 34px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
`;
